<template>
  <v-dialog v-model="open" width="1000px">
    <v-card class="grid" :height="planDataDynamicHeight">
      <!-- close -->
      <v-toolbar elevation="0" class="ml-2 mt-2">
        <span class="planDataModalTitle textType3--text"
          >{{ $t('message.pages.planDataModal.title') }}
        </span>
        <v-spacer />
        <v-toolbar-items>
          <v-icon @click="handleClose" class="mr-2" style="cursor: pointer"
            >mdi-close</v-icon
          >
        </v-toolbar-items>
      </v-toolbar>
      <!-- steps -->
      <v-card-text v-if="planInfo.subscription" class="px-6 pb-6">
        <v-row no-gutters>
          <v-col cols="12" v-if="checkPlanStatus">
            <v-card
              class="d-flex flex-row align-center justify-center trialAlertCard mb-3 pa-4"
              width="100%"
              height="72px"
              flat
            >
              <simple-svg :src="require('@/assets/panda_octainfo_icon.svg')" />
              <v-col>
                <span class="trialText1">
                  {{ $t('message.pages.planDataModal.trialMsg1') }}
                </span>
                <br />
                <span class="trialText2">{{
                  $t('message.pages.planDataModal.trialMsg2')
                }}</span>
              </v-col>
              <v-btn
                elevation="0"
                color="#BF3FEE"
                dark
                @click="handleActivePlan"
              >
                <span>{{ $t('message.pages.planDataModal.trialBtn') }}</span>
              </v-btn>
            </v-card>
          </v-col>
          <v-col cols="12" class="mt-2">
            <v-row no-gutters>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      class="planDataSubtitleText textType3--text textType3--text"
                      >{{ $t('message.pages.planDataModal.planData') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    {{ userPlanInfo.subscription.name }} +
                    {{ $t('message.pages.planDataModal.addon') }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.startCycle') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">
                      {{
                        getFormattedDate(
                          userPlanInfo.subscription.current_period_end,
                          true
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span v-if="planInfo.customer_created_at"
                      >{{
                        $t('message.pages.planDataModal.planStartText').replace(
                          'XXX',
                          getFormattedDate(planInfo.customer_created_at)
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      :color="$vuetify.theme.dark ? 'btnColor' : 'primary'"
                      small
                      class="elevation-0"
                      @click="handlePlansPage"
                    >
                      <span
                        >{{ $t('message.pages.planDataModal.changePlan') }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.endCycle') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text"
                      >{{
                        $t('message.pages.planDataModal.inDays').replace(
                          'XXX',
                          daysToEndCycle()
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="
                      userPlanInfo.subscription &&
                      userPlanInfo.subscription.current_period_end
                    "
                  >
                    <span>
                      {{
                        getFormattedDate(
                          userPlanInfo.subscription.current_period_end
                        )
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.updateData') }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="planInfo.limit && planInfo.limit.updated_at"
                  >
                    <span class="infoText textType3--text">
                      {{ getFormattedDateString(planInfo.limit.updated_at) }}
                    </span>
                  </v-col>
                  <!-- <v-col cols="12">
                      <span>
                        20 minutos
                        {{ $t('message.pages.planDataModal.timeAgo') }}
                      </span>
                    </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider class="my-4" />
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="planDataSubtitleText textType3--text"
                      >{{ $t('message.pages.planDataModal.storage') }}
                    </span>
                  </v-col>
                  <v-col cols="12" v-if="planInfo.limit.trusted_charge_pos">
                    <v-row no-gutters>
                      <v-card
                        class="d-flex flex-row align-center justify-center px-1 elevation-0 rechargeCard"
                        color="#EDEEF1"
                      >
                        <v-card
                          class="elevation-0 ml-1 mr-2"
                          width="4px"
                          height="4px"
                          color="#3F55EE"
                          style="border-radius: 16px"
                        ></v-card>
                        <span
                          :class="{
                            'primary--text': $vuetify.theme.dark,
                          }"
                          >{{
                            $t('message.pages.planDataModal.autoRecharge')
                          }}</span
                        >
                      </v-card>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.totalBought') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">
                      {{ userStorage }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="btnColor"
                      small
                      class="elevation-0"
                      @click="handlePlansPage"
                    >
                      <span>
                        + {{ $t('message.pages.planDataModal.add') }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.used') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span
                      class="infoText textType3--text"
                      :class="{
                        'error--text': closeToLimitStorage || reachLimitStorage,
                      }"
                      >{{ getTextUsedStorage() }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.available') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span
                      class="infoText textType3--text"
                      :class="{
                        'error--text': closeToLimitStorage || reachLimitStorage,
                      }"
                      >{{ getAvailableStorage() }}</span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="closeToLimitStorage || reachLimitStorage"
                  >
                    <v-row no-gutters>
                      <v-card
                        class="d-flex flex-row align-center justify-center px-1 elevation-0 rechargeCard"
                        color="#FFCDD2"
                      >
                        <span class="error--text">
                          {{
                            closeToLimitStorage
                              ? $t('message.pages.planDataModal.closeToLimit')
                              : $t(
                                  'message.pages.planDataModal.reachedStorageLimit'
                                )
                          }}
                        </span>
                      </v-card>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider class="my-4" />
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="planDataSubtitleText textType3--text"
                      >{{ $t('message.pages.planDataModal.monthlyTraffic') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span
                      class="primary--text newLinkText"
                      style="cursor: pointer"
                      @click="openBandwidthDisclosure"
                    >
                      {{ $t('message.pages.planDataModal.analyzeUsage') }}
                      <v-icon size="12" color="primary">mdi-open-in-new</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.totalBought') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">{{
                      userTraffic
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="btnColor"
                      small
                      class="elevation-0"
                      @click="handlePlansPage"
                    >
                      <span>
                        + {{ $t('message.pages.planDataModal.add') }}
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.used') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">
                      {{ getUsedTraffic() }}
                    </span>
                  </v-col>
                  <v-col
                    v-if="
                      estimativeHigherThanHired && userPlanInfo.subscription
                    "
                    cols="12"
                  >
                    <span
                      class="error--text"
                      style="font-size: 12px; text-decoration: none !important"
                    >
                      {{
                        $t(
                          'message.pages.planDataModal.estimatedTraffic'
                        ).replace('XXX', estimatedTraffic)
                      }}
                      {{
                        getFormattedDate(
                          userPlanInfo.subscription.current_period_end
                        )
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"
                      >{{ $t('message.pages.planDataModal.available') }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">{{
                      getAvailableTraffic()
                    }}</span>
                  </v-col>
                  <v-col cols="12" v-if="surpassLimitTraffic">
                    <v-card
                      class="d-flex flex-row align-center justify-center px-1 elevation-0 rechargeCard"
                      color="#FFCDD2"
                      style="max-width: 190px"
                    >
                      <span class="error--text">
                        {{ $t('message.pages.planDataModal.reachLimit') }}
                        {{ surpassedLimitTrafficValue }}
                      </span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider class="my-4" />
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="planDataSubtitleText textType3--text"
                      >{{ $t('message.pages.planDataModal.credit') }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="my-1"
                    v-if="hasAutomaticCreditRecharge"
                  >
                    <v-row no-gutters>
                      <v-card
                        class="d-flex flex-row align-center justify-center px-1 elevation-0 rechargeCard"
                        color="#EDEEF1"
                      >
                        <v-card
                          class="elevation-0 ml-1 mr-2"
                          width="4px"
                          height="4px"
                          color="#3F55EE"
                          style="border-radius: 16px"
                        ></v-card>
                        <span
                          :class="{
                            'primary--text': $vuetify.theme.dark,
                          }"
                          >{{
                            $t('message.pages.planDataModal.autoRecharge')
                          }}</span
                        >
                      </v-card>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <span
                      class="primary--text newLinkText"
                      style="cursor: pointer"
                      @click="openCreditArticle"
                    >
                      {{ $t('message.pages.planDataModal.learnHowToUse') }}
                      <v-icon size="12" color="primary">mdi-open-in-new</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitlesText textType4--text"> TOTAL </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="infoText textType3--text">{{
                      accountBalance
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="btnColor"
                      small
                      class="elevation-0"
                      @click="handleGoToCreditDetails"
                    >
                      <v-row no-gutters align="center" justify="center">
                        <img
                          class="mr-1"
                          src="@/assets/credit_small_icon.svg"
                        />
                        <span>
                          {{ $t('message.pages.planDataModal.buyCredits') }}
                        </span>
                      </v-row>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
// external imports
import { mapMutations, mapState } from 'vuex'
import batchAiMixin from '@/utils/batchAiGenerationDubbingModal.mixin'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import planApi from '@/services/planApi'
export default {
  name: 'PlanDataModal',
  components: {},
  props: {
    data: Object,
  },
  mixins: [batchAiMixin, calcMegabytesMixin],
  data: () => ({
    open: false,
    userStorage: '',
    userTraffic: '',
    creditsBalance: 0,
    estimatedTraffic: 0,
    estimativeHigherThanHired: false,
    closeToLimitStorage: false,
    reachLimitStorage: false,
    reachedLimitTraffic: false,
    overusedTraffic: 0,
    surpassedLimitTrafficValue: 0,
    hasAutomaticCreditRecharge: false,
  }),
  computed: {
    ...mapState('user', {
      folders: 'mainFolders',
      planInfo: 'userPlanInfo',
      isMobileBreakpoint: 'isMobileBreakpoint',
      userFirstAccess: 'userFirstAccess',
      userPermissions: 'userPermissions',
      navItems: 'navItems',
      userAllInfo: 'userAllInfo',
      userPlanInfo: 'userPlanInfo',
    }),
    surpassLimitTraffic() {
      let totalTraffic = this.userPlanInfo.limit?.traffic_plan
      let usedTraffic = this.planInfo.limit.traffic
      return totalTraffic <= usedTraffic
    },
    planDataDynamicHeight() {
      let planStatus = this.planInfo?.subscription?.status
      if (planStatus === 'trialing') return '600px'
      return '550px'
    },
    checkPlanStatus() {
      if (this.planInfo?.subscription?.status === 'trialing') return true
      return false
    },
  },
  created() {
    this.getCreditRechargeInfo()
  },
  mounted() {
    this.$root.$on('openPlanDataModal', () => {
      this.open = true
      this.setUserInfo()
    })
  },
  watch: {},
  beforeDestroy() {
    this.$root.$off('openOnboardingModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_FIRST_ACCESS', 'UPDATE_ONLY_CUSTOMIZING']),
    handleActivePlan() {
      this.$root.$emit('ModalResetBillingCycle')
      this.handleClose()
    },
    async getCreditRechargeInfo() {
      try {
        await planApi.getCreditsAutoRechargeSettings()
        this.hasAutomaticCreditRecharge = true
      } catch (error) {
        const {
          response: { status: statusCode },
        } = error
        if (statusCode == 404) {
          this.hasAutomaticCreditRecharge = false
        }
      }
    },
    setUserInfo() {
      this.getCreditRechargeInfo()
      this.userStorage = this.calcMegabytes(
        this.userPlanInfo.limit?.storage_plan,
        'MB',
        'GB',
        true
      )
      this.userStorage = this.calcMegabytes(
        this.userPlanInfo.limit?.storage_plan,
        'MB',
        'GB',
        true
      )
      let trafficInMb =
        this.userPlanInfo?.subscription?.status === 'trialing'
          ? Number(this.userPlanInfo.subscription.metadata.transfer) * 1024
          : this.userPlanInfo?.limit?.traffic_plan ?? 0
      this.userTraffic = this.calcMegabytes(trafficInMb, 'MB', 'GB', true)
      this.estimatedTraffic = this.planInfo?.limit?.estimated_traffic ?? 0
      if (
        this.planInfo?.limit?.estimated_traffic >
        this.planInfo?.limit?.traffic_plan
      )
        this.estimativeHigherThanHired = true
      if (this.planInfo?.limit?.storage >= this.planInfo?.limit?.storage_plan) {
        this.reachLimitStorage = true
      } else if (
        this.planInfo?.limit?.storage * 1.1 >
        this.planInfo?.limit?.storage_plan
      ) {
        this.closeToLimitStorage = true
      }
      let totalTraffic = this.planInfo?.limit?.traffic_plan
      let usedTraffic = this.planInfo?.limit?.traffic
      let diffValue = totalTraffic - usedTraffic ?? 0
      if (diffValue < 0) {
        let prefSize = diffValue > 1000000 ? 'TB' : 'GB'
        this.surpassedLimitTrafficValue = this.calcMegabytes(
          diffValue,
          'MB',
          prefSize,
          true
        )
      }
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    getFormattedDate(date, monthAgoFlag) {
      let formattedDate = new Date(date * 1000)
      if (monthAgoFlag) {
        formattedDate.setMonth(formattedDate.getMonth() - 1)
      }
      return formattedDate.toLocaleDateString(this.getLocale())
    },
    getFormattedDateString(dateString) {
      let formattedDate = new Date(dateString)
      return formattedDate.toLocaleDateString(this.getLocale())
    },
    daysToEndCycle() {
      const currentPeriodEnd =
        this.userPlanInfo.subscription?.current_period_end * 1000
      const endDate = new Date(currentPeriodEnd)
      const today = new Date()
      const differenceInMs = endDate - today
      const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24))
      return differenceInDays
    },
    handleGoToCreditDetails() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
      this.handleClose()
    },
    handlePlansPage() {
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.$router.push({ name: 'Cart' })
      this.$root.$emit('isChangingPlan', true)
      this.handleClose()
    },
    handleCustomPlanPage() {
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$root.$emit('onlyCustumizingByPlanModal', true)
      this.$router.push({ name: 'Cart' })
      this.handleClose()
    },
    getTextUsedStorage() {
      let textStorage = String(
        this.calcMegabytes(this.planInfo?.limit?.storage, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStorage
    },
    getTextTotalStorage() {
      let textStoragePlan = String(
        this.calcMegabytes(this.planInfo?.limit?.storage_plan, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStoragePlan
    },
    getAvailableStorage() {
      let sum =
        this.planInfo?.limit?.storage_plan - this.planInfo?.limit?.storage
      if (sum < 0) sum = 0
      let textStoragePlan = String(
        this.calcMegabytes(sum, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStoragePlan
    },
    getAvailableTraffic() {
      let sum =
        this.planInfo?.limit?.traffic_plan - this.planInfo?.limit?.traffic
      if (sum < 0) sum = 0
      let text = String(this.calcMegabytes(sum, 'MB', 'GB', true)).replace(
        ',',
        '.'
      )
      return text
    },
    getUsedTraffic() {
      const usedTraffic = String(
        this.calcMegabytes(this.planInfo?.limit?.traffic, 'MB', 'GB', true)
      ).replace(',', '.')
      return usedTraffic
    },
    openCreditArticle() {
      window.open(
        'https://help.pandavideo.com/pt-br/article/como-funcionam-os-creditos-da-panda-video-sl8v0f/',
        '_blank'
      )
    },
    openBandwidthDisclosure() {
      this.$root.$emit('changeNavItem', 5)
      this.$router.push({ name: 'AnalyticsV2Bandwidth' })
      this.handleClose()
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>
<style lang="scss" scoped>
.trialAlertCard {
  border-radius: 4px;
  border: 1px solid #bf3fee;
  background: #fcf5ff;
}
</style>
<style>
.planDataModalTitle {
  font-size: 20px;
  font-weight: 500;
}
.infoText {
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
}
.subtitlesText {
  font-size: 11px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.66px;
  text-transform: uppercase;
}
.planDataSubtitleText {
  font-size: 14px;
  font-weight: 500;
}
.trialText1 {
  color: #5f1e77;
  font-size: 14px;
  font-weight: 500;
}
.trialText2 {
  color: #636578;
  font-size: 12px;
  font-weight: 400;
}
.rechargeCard {
  border-radius: 8px !important;
}
.newLinkText {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%; /* 18px */
}
</style>
